<template>
  <div>
    <h2 style="margin: 20px">菜单管理</h2>
    <md-button style="margin: 10px" type="primary" @click="dialogFormVisible = true" class="mr20">导入</md-button>
    <md-table
      ref="MnTable"
      :data="tableData"
      :height="height"
      style="width: 100%; margin-bottom: 20px"
      row-key="baseMenuId"
      :tree-props="{
        children: 'subNodes', // 指定子节点用哪个字段
        // hasChildren: 'hasChildren', 懒加载的时候用于加标记
      }"
    >
      <md-table-column prop="menuNameZh" label="名称" minWidth="200"></md-table-column>
      <md-table-column prop="menuCode" label="标识" minWidth="200"></md-table-column>
      <md-table-column prop="status" label="状态" minWidth="100">
        <template slot-scope="scope">
          {{ scope.row.status === 'Y' ? '有效' : '无效' }}
        </template>
      </md-table-column>
      <md-table-column prop="menuUrl" label="路径" minWidth="200"></md-table-column>
      <md-table-column prop="name" label="操作" minWidth="300">
        <template slot-scope="scope">
          <div v-for="item in btnList" :key="item.id" style="float: left;">
            <md-button @click="item.handel(scope.row)"  class="editBtn">{{ item.label }}</md-button>
          </div>
        </template>
      </md-table-column>
    </md-table>

    <!-- 弹框 -->
    <menuDialog ref="menuDialog" @sbmitForm="sbmitForm" v-if="dialogVisible" @closeDialog="closeDialog" />
    <md-dialog title="选择导入文件" v-dialogDrag :fullscreen="false" :visible.sync="dialogFormVisible" width="30%">
      <div style="margin-top: -20px; float: right;">
        <md-button type="primary" @click="downloadFileFlex"> 点击下载菜单管理导入模板 </md-button>
      </div>
      <md-form style="margin-top: -20px; float: left;">
        <md-upload
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          action='/gscint/menu/importExcel'
          :multiple='false'
          :show-file-list='false'
          :with-credentials='true'
          :on-success='uploadExcel'
        >
          <md-button size="small" type="primary" icon='el-icon-upload'>上传附件</md-button>
        </md-upload>
      </md-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click='expTemplate' v-show="this.form.billType == 10">下载模板</el-button>
      </div> -->
    </md-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import menuDialog from '../dialog/menu-dialog.vue';

export default {
  name: 'DmrWebIndex',
  components: { menuDialog },
  data() {
    return {
      dialogFormVisible: false,
      height: 0,
      tableData: [],
      btnList: [
        { label: '新增菜单', id: 1, handel: this.add },
        { label: '修改', id: 2, handel: this.edit },
        { label: '删除', id: 3, handel: this.delete },
        { label: '查看', id: 4, handel: this.check },
      ],
      dialogVisible: false,
    };
  },

  created() {
    this.queryMenu();
  },
  mounted() {
    this.heightInit();
  },

  methods: {
    // 查询
    queryMenu() {
      axios.get('/gscint/menu/query').then(res => {
        if (res.data.data.code === '1') {
          this.tableData = res.data.data.datas;
        } else {
          this.$MdMessage.warning(res.data.data.datas);
        }
      });
    },
    // 新增
    add(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.menuDialog.form.parentCode = row.menuCode;
        this.$refs.menuDialog.form.menuLevel = row.menuLevel + 1; // 设置菜单层级
        this.$refs.menuDialog.visible = true;
      });
    },
    // 关闭弹框
    closeDialog() {
      this.dialogVisible = false;
    },
    downloadFile(data, filename) {
      if (!data) {
        return;
      }
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    // 下载导入模板
    downloadFileFlex() {
      axios({
        url: '/gscint/menu/downLoadExample',
        method: 'get',
        headers: { 'content-type': 'application/json; charset=utf-8' },
        responseType: 'blob',
      }).then((res) => {
        this.downloadFile(res.data, '系统菜单导入模板.xlsx');
      });
    },
    // 导入模板
    uploadExcel(res) {
      if (res.success) {
        this.dialogFormVisible = false;
        this.$MdMessage.success('导入成功!');
        this.queryMenu();
      } else {
        this.dialogFormVisible = false;
        this.$MdMessage.warning(res.msg);
      }
    },
    // 弹框返回
    sbmitForm(form) {
      const url = form.baseMenuId ? '/gscint/menu/update' : '/gscint/menu/add';
      if (!form.baseMenuId) {
        form.menuSystem = 'GSC_I';
      }
      if (!form.iconUrl) {
        form.iconUrl = 'md-icon-database-outline';
      }
      axios.post(url, form).then((res) => {
        if (res.data.data.code === '1') {
          this.$MdMessage.success('保存成功');
          this.queryMenu();
          this.dialogVisible = false;
        } else {
          this.$MdMessage.warning(res.data.msg);
        }
      });
    },
    edit(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.menuDialog.form = Object.assign({}, row, {
          type: row.menuUrl && row.menuUrl !== '菜单' ? '2' : '1',
        });
        this.$refs.menuDialog.title = '修改菜单';
        this.$refs.menuDialog.visible = true;
      });
    },

    delete(row) {
      this.$MdConfirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false,
      }).then(() => {
        axios
          .post('/gscint/menu/delete', {
            baseMenuId: row.baseMenuId,
          })
          .then((res) => {
            if (res.data.data.code === '1') {
              this.$MdMessage.success('删除成功');
              this.queryMenu();
            } else {
              this.$MdMessage.warning(res.msg);
            }
          });
      });
    },
    check(row) {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.menuDialog.title = '查看菜单';
        this.$refs.menuDialog.form = Object.assign({}, row);
        this.$refs.menuDialog.readonly = true;
        this.$refs.menuDialog.visible = true;
      });
    },

    // 表格高度初始化
    heightInit() {
      this.$nextTick(() => {
        if (this.$attrs.height) {
          this.height = this.$attrs.height > 0 ? this.$attrs.height + 'px' : this.$attrs.height;
          this.treeHeight = this.$attrs.height > 0 && this.$attrs.height + 42 + 52 + 'px'; // 表格高度 + 分页 + 表单高度
        } else {
          // 表格高度计算 top(表格往上的总高度) - 64(分页44 + content的padding-bottom 10 + 灰色底10)
          const bottom = this.$attrs.bottom ? this.$attrs.bottom : 64;
          this.$watch('tab', () => {
            const table = this.$refs.MnTable;
            const tops = table.$el.getBoundingClientRect().top;
            if (tops > 0) {
              this.height = window.innerHeight - tops - bottom + 44 + 'px';
              table.doLayout();
              this.treeHeight = window.innerHeight - tops - bottom + 42 + 52 + 44 + 'px'; // 表格高度 + 分页 + 表单高度
            }
          }, {
            immediate: true,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  /deep/.head-title {
    font-size: 20px;
  }
}
.editBtn {
  border: none;
  background: rgba(0, 0, 0, 0);
  padding: 0;
  margin-right: 8px;
  &:hover {
    background: rgba(0, 0, 0, 0);
    color: rgb(127, 127, 253);
  }
}
</style>
